import utils from "../../utils";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import classNames from "classnames";

import React, { useRef } from "react";

import "./index.scss";

interface iBaseSearch {
  title: string;
  value: string;
}
interface iOnChange {
  searchedValue: string;
  base: iBaseSearch;
}
type Props = {
  size?: string;
  icon?: string;
  width?: number;
  textAlign?: "right" | "left" | "center";
  placeHolder?: string | null;
  defaultSearch?: string;
  onChangeSearch: (item: iOnChange) => void;
  baseSearchItems: iBaseSearch[];
  defaultBaseSearch: iBaseSearch;
};
const userDirection = Cookies.get(constants.USER_DIRECTION);
const CustomDropdownSearch2 = ({
  width,
  placeHolder,
  defaultSearch,
  onChangeSearch,
  baseSearchItems,
  defaultBaseSearch,
  size = "medium-sd",
  icon = "fa-solid fa-magnifying-glass",
  textAlign = userDirection === "ltr" ? "left" : "right",
}: Props) => {
  const selectSearchRef = React.useRef<HTMLInputElement | null>(null);
  const [isOpenDropdown, setIsOpenDropdown] = React.useState(false);
  const [selectedBaseSearch, setSelectedBaseSearch] =
    React.useState<iBaseSearch>(defaultBaseSearch);

  const inputRef = useRef<HTMLInputElement>(null);

  document.addEventListener("mousedown", (event: any) => {
    if (!selectSearchRef?.current?.contains(event.target)) {
      setIsOpenDropdown(false);
    }
  });

  if (!placeHolder) placeHolder = "جستجو...";

  return (
    <section id="custom-dropdown-search-container" style={{ width: width }}>
      <div className={size}>
        {/* input */}
        <div className="custom-search-container">
          {icon && <i className={icon} />}
          <input
            ref={inputRef}
            onChange={(e) => {
              onChangeSearch({
                searchedValue: utils.convertNumbers2English(
                  e.currentTarget.value
                ),
                base: selectedBaseSearch,
              });
            }}
            placeholder={placeHolder ? placeHolder : undefined}
            value={defaultSearch}
            className={classNames(textAlign)}
          />
        </div>
        {/* X-mark */}
        <div
          className="x-mark"
          onClick={() =>
            onChangeSearch({ searchedValue: "", base: selectedBaseSearch })
          }
        >
          {defaultSearch !== undefined && defaultSearch !== "" && (
            <i className={"fa-solid fa-xmark"} />
          )}
        </div>
        {/* dropdown */}
        <div className="custom-dropdown-container" ref={selectSearchRef}>
          <div
            className="dropdown-selection"
            onClick={() => {
              setIsOpenDropdown(!isOpenDropdown);
            }}
          >
            <div className="dropdown-title">{selectedBaseSearch.title}</div>
            <div className="dropdown-icon">
              {isOpenDropdown ? (
                <i
                  className={classNames("fa-solid fa-chevron-down", {
                    "dropdown-arrow-down": isOpenDropdown,
                  })}
                />
              ) : (
                <i
                  className={classNames("fa-solid fa-chevron-up", {
                    "dropdown-arrow-up": !isOpenDropdown,
                  })}
                />
              )}
            </div>
          </div>
          {isOpenDropdown && (
            <div className="dropdown-content">
              {baseSearchItems.map((item, index) => (
                <div
                  className={classNames("dropdown-text", {
                    "selected-item": item.value === selectedBaseSearch.value,
                  })}
                  onClick={() => {
                    setIsOpenDropdown(!isOpenDropdown);
                    setSelectedBaseSearch(item);
                    onChangeSearch({
                      searchedValue: "",
                      base: selectedBaseSearch,
                    });
                    inputRef.current?.focus();
                  }}
                  key={`base-${index}`}
                >
                  {item.value === selectedBaseSearch.value && (
                    <i className="fa-solid fa-check" />
                  )}
                  {item.title}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CustomDropdownSearch2;
